module.exports = __webpack_public_path__ + "img/triste.903ac1ca.png";